/**
 * Modèle représentant un fournisseur
 */
import {ListItem} from "@domain/common/list-view/list-item";
import {ListeAlertes} from "@domain/common/alerte/listeAlertes";
import {OrgaDTO} from "@domain/admin/entreprise/analytique/orgaDTO";

export class Fournisseur implements ListItem {
    idFournisseur: number;
    raisonSociale: string;
    devise: string;
    codeFournisseur: string;
    orga: OrgaDTO;
    actif: boolean;
    siren: string;
    siret: string;
    numeroIntracom: string;
    idOrga: number;
    libelleOrga: string;
    compteTiers: string;
    numContrat: string;
    compteAuxiliaire: string;
    conditionPaiement: string;
    iban: string;
    bic: string;
    rib: string;
    domiciliation: string;
    numeroCompte: string;
    idLocalisation: number;
    isSelected?: boolean;
    listeAlertes?: ListeAlertes;

    constructor(dto: any) {

        if (dto) {
            this.idFournisseur = dto.idFournisseur;
            this.raisonSociale = dto.raisonSociale;
            this.devise = dto.devise;
            this.codeFournisseur = dto.codeFournisseur;
            this.actif = dto.isActif;
            this.siren = dto.siren;
            this.siret = dto.siret;
            this.numeroIntracom = dto.numeroIntracom;
            this.orga = dto.orga;
            this.idOrga = dto.idOrga;
            this.libelleOrga = dto.libelleOrga;
            this.compteTiers = dto.compteTiers;
            this.numContrat = dto.numContrat;
            this.compteAuxiliaire = dto.compteAuxiliaire;
            this.conditionPaiement = dto.conditionPaiement;
            this.iban = dto.iban;
            this.bic = dto.bic;
            this.rib = dto.rib;
            this.domiciliation = dto.domiciliation;
            this.numeroCompte = dto.numeroCompte;
            this.idLocalisation = dto.idLocalisation;
        }
    }

    /**
     * Récupération de l'identifiant de l'objet
     * @returns L'identifiant du fournisseur
     */
    getKey(): number | string {
        return this.idFournisseur;
    }
}